
import Vue from "vue";
import Component from "vue-class-component";
import rely from "@/nmb/oauth2/oauth2rely";
import { Prop, Watch } from "vue-property-decorator";
import config from "@/params/config";
import ChooseConfig from "./chooseConfig.vue"; // 引入 chooseConfig 组件
import { Action, Getter } from "vuex-class";
import ChooseUsers from "./chooseUsers.vue";
import ProductDoc from "./ProductDoc.vue";
import systemConfigSet from "./systemConfigSet.vue";
import ProdcutSupport from "./ProdcutSupport.vue";
import ProductEvn from "./ProductEvn.vue";
import axios from "axios";
import { Message } from "element-ui";

@Component({ components: { ChooseConfig, ChooseUsers, ProductDoc, ProdcutSupport, systemConfigSet, ProductEvn } })
export default class AdminHome extends Vue {
  @Getter accessUser: any;
  @Action("getAccessUsers") getAccessUsers: Function;

  @Getter adminUser: any;
  @Action("getAdminUsers") getAdminUsers: Function;

  @Getter productDocs: any;
  @Action("getDocProducts") getDocProducts: Function;

  @Getter productDocById: any;
  @Action("getDocProductById") getDocProductById: Function;

  @Getter backgroundDoc: any;
  @Action("getBackProductDocDTO") getBackProductDocDTO: Function;

  @Getter setAdminUser: any;
  @Action('setAdminUsers') setAdminUsers: Function;

  @Action('syncDocFiles') syncDocFiles: Function;
  @Action('deleteDocProduct') deleteDocProduct: Function;

  tableKey: number = 2; // 用于强制重新渲染列表

  action: string = config.neo + "/StudyMap/Import";
  currentPage: number = 1; // 当前页码
  pageSize: number = 10; // 每页显示条数
  activeIndex: any = "1";
  chooseEmployeeVisible: boolean = false;
  chooseAdminVisible: boolean = false;
  choosePropVisible: boolean = false;
  chooseVisible: boolean = false;

  currentProductDoc: any = {};
  chooseProductDocVisible: boolean = false;
  currentConfigGUID: string = ""; // 用于存储当前选择的 ConfigGUID

  currentAccessInfo: any = {};
  currentAdminInfo: any = {};
  currentInfo: any = {};

  importloading: boolean = false;
  timer: any = null;
  
  created() {
    const user = rely.getLogonUser();
  }
  mounted() {
    this.reqAccessUsers();
    this.reqAdminUsers();
    this.getDocProductTableList();
    this.getBackProductDocDTO({ code: "" });
  }

  addDocType(){
    var nextSortNum = null;
    if(this.productDocs.infos && this.productDocs.infos.length > 0){
      nextSortNum = this.productDocs.infos.map((a: any) => a.SortOrder).sort().pop() + 1;
    }
    this.currentProductDoc = {IsEnabled: 1, ProductType: 1, SortOrder: nextSortNum};
    this.chooseProductDocVisible = true;
  }

  addProduct(row: any) {
    var nextSortNum = null;
    if(row.children && row.children.length > 0){
      nextSortNum = row.children.map((a: any) => a.SortOrder).sort().pop() + 1;
    }
    this.currentProductDoc = {IsEnabled: 1, IsHome: 0, ProductType: 2, ParentGUID: row.DocProductGUID, DocVersions:[], SortOrder: nextSortNum};
    this.chooseProductDocVisible = true;
  }

  editDoc(row: any){
    this.currentProductDoc = JSON.parse(JSON.stringify(row));
    this.chooseProductDocVisible = true;
  }

  syncFiles(row: any){
    this.syncDocFiles(row).then(()=>{
      this.getDocProductTableList();
    })
  }

  getDocProductTableList(){
    this.getDocProducts({CalcProcessValue: true}).then(()=>{
      this.repeatGetDocProductProccess(false);
    })
  }

  repeatGetDocProductProccess(isRepeat: boolean) {
    var allProdcuts = this.productDocs.infos.flatMap((item: any) => item.children);
    var docWithProccess = (allProdcuts && allProdcuts.filter((item: any) => item.ProccessValue)) || [];
    if(docWithProccess.length > 0){
      if(isRepeat){
        // 更新进度值，更新时间
        docWithProccess.forEach((item: any) => {
          var matchs = (this.productDocById.infos && this.productDocById.infos.filter((a: any) => a.DocProductGUID === item.DocProductGUID)) || [];
          if(matchs.length > 0){
            this.$set(item, 'ProccessValue', matchs[0].ProccessValue);
            this.$set(item, 'LastSyncTimeStr', matchs[0].LastSyncTimeStr);
          }
        });
      }
      var prodcutIds = docWithProccess.map((item: any) => item.DocProductGUID);
      this.timer = setTimeout(()=> {
        this.getDocProductById({TargetProductIDs: prodcutIds, CalcProcessValue: true}).then(()=>{
          this.repeatGetDocProductProccess(true);
         })
      }, 3000)
    }else {
      if(this.timer){
        clearTimeout(this.timer);
        this.timer = null;
      }
    }
  }

  deleteDoc(row: any){
    var target = row.ProductType == 1 ? row.Name + "分类及其子级产品" : row.Name;
    var notice = "确认删除 <strong>" + target + "</strong> 吗？"
    this.$confirm(notice, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      dangerouslyUseHTMLString: true,
      type: 'warning'
    }).then(() => {
      this.deleteDocProduct({docProductId:row.DocProductGUID}).then(()=>{
        this.getDocProductTableList();
      })
    });
  }

  // 切换分类页签
  handleSelect(key: string) {
    this.activeIndex = key;
    // this.$router.replace({path:'/feedback',query:{activeIndex:key}})
    console.log(this.backgroundDoc);
  }

  refreshProductData() {
    this.tableKey += 1;
    this.getBackProductDocDTO({ code: "" })
      .then(() => {
        //console.log("触发刷新了");
        this.tableKey += 1;
      })
      .then(() => {});
    this.$nextTick(() => {
      //console.log("触发刷新了next");
      this.tableKey += 1;
    });

    setTimeout(() => {
      // 要延迟执行的操作
      //console.log("触发刷新了delay");
      this.tableKey += 1;
    }, 4000); // 延迟1秒
  }

  // pageSize 每页显示条数发生改变
  handleSizeChange(val: number) {
    this.pageSize = val;
    this.reqAccessUsers();
  }
  //弹出设置界面
  openSet(obj: any) {
    this.currentInfo = obj.Code;
    this.chooseVisible = true;
  }

  openPropSet(obj: any) {
    console.log(obj);
    this.currentConfigGUID = obj.ConfigGUID; // 设置当前 ConfigGUID
    this.choosePropVisible = true; // 打开弹窗

    console.log(this.choosePropVisible);
    //传递给子组件
  }

  // currentPage 当前页码发生改变
  handleCurrentChange(val: number) {
    this.currentPage = val;
    this.reqAccessUsers();
  }

  // 请求查询接口
  reqAccessUsers() {
    this.getAccessUsers({ PageIndex: this.currentPage, PageSize: this.pageSize });
  }

  // 请求查询接口
  reqAdminUsers() {
    this.getAdminUsers({});
  }

  convetUserNames(row: any) {
    let names = "";
    if (row.UserInfos && row.UserInfos.length > 0) {
      for (const item of row.UserInfos) {
        names += item.PmName + "，";
      }
      names = names.length > 0 ? names.substring(0, names.length - 1) : names;
    }

    return names;
  }

  // 打开弹窗
  handleChange(row: any) {
    this.currentAccessInfo = row;
    this.chooseEmployeeVisible = true;
  }

  // 打开弹窗
  handleChangeAdmin(row: any) {
    this.currentAdminInfo = JSON.parse(JSON.stringify(row));
    this.chooseAdminVisible = true;
  }

  // 关闭显隐设置界面
  closeChooseVisible(close: boolean) {
    if (close) {
      //刷新
    }
    this.chooseVisible = false;
  }

  closeProductDocVisible(close: boolean) {
    this.chooseProductDocVisible = false;
    this.getDocProductTableList();
  }

  // 关闭选择属性弹窗
  closeChoosePropVisible(close: boolean) {
    if (close) {
      // colse = true, 刷新页面
      this.reqAccessUsers();
    }
    this.choosePropVisible = false;
  }

  // 关闭选择人员弹窗
  closeChooseEmployeeVisible(close: boolean) {
    if (close) {
      // colse = true, 刷新页面
      this.reqAccessUsers();
    }
    this.chooseEmployeeVisible = false;
  }

   // 关闭选择人员弹窗
  closeChooseAdminVisible(close: boolean) {
    if (close) {
      // colse = true, 刷新页面
      this.reqAdminUsers();
    }
    this.chooseAdminVisible = false;
  }

  cellStyle({ row, column, rowIndex, columnIndex }: any){
    return {
        padding: '6px 0'
      }
  }

  // 关闭选择人员弹窗
  selectedAdmins(data: any) {
    this.chooseAdminVisible = false;
    if (data) {
      this.setAdminUsers({UserInfos:data});
    }
  }

  // 上传出错
  handleError(err: any, file: any) {
    this.$message.error(`文件${file.name}上传失败`);
    this.importloading = false;
  }
  // 上传成功
  handleSuccess(response: any, file: any, fileList: any) {
    this.importloading = false;
    if (response.Success) {
      this.$message.success(`文件${file.name}上传成功`);
    } else {
      this.$message.error(response.Message);
    }
  }

  // 准备上传
  handlerBeforeUpload(file: any) {
    if (file.size > 1024 * 1024 * 20) {
      this.$message({ type: "warning", message: `文件上传限制为20M` });

      return false;
    } else if (file.size === 0) {
      this.$message({ type: "warning", message: `文件${file.name}大小为空` });
    }
    this.importloading = true;
  }

  eport() {
    const fileName = "学习地图模板.xls";
    const tokens = rely.getTokens();
    const axiosConfig = {
      method: "get",
      url: `${config.neo}/StudyMap/Export`,
      headers: {
        Authorization: `Bearer ${tokens.access_token}`,
      },
      responseType: "blob",
    };

    axios(axiosConfig)
      .then((res) => {
        const blob = res.data;
        if (blob.size < 200) {
          this.$message.error(`文件${fileName}下载失败`);
          return;
        }
        if (window.navigator.msSaveBlob) {
          // IE10+ 使用的下载方式
          return window.navigator.msSaveBlob(blob, fileName);
        }
        // 其他浏览器下载方式
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = (e: any) => {
          const a: any = document.createElement("a");
          a.download = fileName;
          a.href = e.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      })
      .catch((err: any) => {
        this.$message.error(`文件${fileName}下载失败`);
      });
  }
}
